"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.groupVariants = exports.getAttributeValue = exports.flattenAttributeValues = exports.buildProductStateObject = exports.buildPath = exports.pivotAttributeValues = void 0;
var fromPairs_1 = __importDefault(require("lodash/fromPairs"));
var mapValues_1 = __importDefault(require("lodash/mapValues"));
var pick_1 = __importDefault(require("lodash/pick"));
var sku_1 = require("./sku");
var imageProxied_1 = __importDefault(require("./imageProxied"));
var INutsProductAttributes = {
    names: [
        'allergens',
        'countPerPound',
        'countryOfOrigin',
        'customPageTitle',
        'customProduct',
        'contentList',
        'density',
        'googleProductCategory',
        'healthTips',
        'hiddenFromDy',
        'hiddenFromSearch',
        'hsCode',
        'ingredients',
        'inMix',
        'instructions',
        'inTray',
        'meltable',
        'merchandisingCategory',
        'nutritionFacts',
        'oneLinerDescription',
        'orderHint',
        'plaDescription',
        'plaEnabled',
        'plaTitle',
        'popularity',
        'primaryCategory',
        'remarketingEnabled',
        'reportingCategory',
        'requiresCustomization',
        'setBackordered',
        'setBackorderedUntil',
        'shortDescription',
        'storageRequirements',
        'tagReferences',
        'testDescription',
        'upsellingProducts',
        'urlName',
        'wholesalePopularity',
    ],
};
var INutsVariantAttributes = {
    names: [
        'active',
        'autoBackorder',
        'autoDeliveryEligible',
        'backordered',
        'backorderedUntil',
        'bagSize',
        'bulk',
        'caffeine',
        'fulfillmentException',
        'grindSize',
        'ordergrooveSkuSwapGroup',
        'sample',
        'servingsPerContainer',
        'snackPack',
        'tinColor',
        'variantName',
        'weight',
        'wholesale',
    ],
};
var pivotAttributeValues = function (attributes) {
    if (attributes === void 0) { attributes = []; }
    var pairs = attributes.map(function (_a) {
        var name = _a.name, value = _a.value;
        return [name, value];
    });
    var values = (0, fromPairs_1.default)(pairs);
    if (values.backordered !== undefined) {
        values.backordered = values.backordered.key === 'yes';
    }
    return {
        product: (0, pick_1.default)(values, INutsProductAttributes.names),
        variant: (0, pick_1.default)(values, INutsVariantAttributes.names),
    };
};
exports.pivotAttributeValues = pivotAttributeValues;
var flattenAttributeValues = function (attributes) {
    var pairs = attributes.map(function (_a) {
        var name = _a.name, value = _a.value;
        return [name, value];
    });
    return flattenValues((0, fromPairs_1.default)(pairs));
};
exports.flattenAttributeValues = flattenAttributeValues;
var flattenValues = function (values) {
    return (0, mapValues_1.default)(values, function (value, name) {
        var _a, _b, _c, _d;
        if (name === 'backordered') {
            return value.key === 'yes';
        }
        return (_d = (_c = (_b = (_a = value.label) === null || _a === void 0 ? void 0 : _a.en) !== null && _b !== void 0 ? _b : value.key) !== null && _c !== void 0 ? _c : value.en) !== null && _d !== void 0 ? _d : value;
    });
};
var getAttributeValue = function (name, attributes) {
    var _a;
    var results = attributes.filter(function (x) { return x.name === name; });
    return (_a = results[0]) === null || _a === void 0 ? void 0 : _a.value;
};
exports.getAttributeValue = getAttributeValue;
var groupBy = function (list, keyGetter) {
    var map = new Map();
    list.forEach(function (item) {
        var key = keyGetter(item);
        var collection = map.get(key);
        if (!collection) {
            map.set(key, [item]);
        }
        else {
            collection.push(item);
        }
    });
    return map;
};
var groupVariants = function (variants) {
    var resultVariants = [];
    var groupedByWeight = groupBy(variants, function (variant) { return variant.weight; });
    groupedByWeight.forEach(function (groupedVars) {
        var resultVariant = groupedVars[0];
        var grindSizeVariation = [];
        var tinColorVariation = [];
        var otherVariations = [];
        var groupedByGrindSize = groupBy(groupedVars, function (x) { return x.grindSize; });
        groupedByGrindSize.forEach(function (value, key) {
            if (key) {
                grindSizeVariation.push({
                    label: key,
                    sku: value[0].sku,
                    unitPrice: value[0].unitPrice,
                });
            }
        });
        var groupedByTinColor = groupBy(groupedVars, function (x) { return x.tinColor; });
        groupedByTinColor.forEach(function (value, key) {
            if (key) {
                tinColorVariation.push({
                    label: key,
                    sku: value[0].sku,
                    unitPrice: value[0].unitPrice,
                });
            }
        });
        if (grindSizeVariation.length > 0) {
            otherVariations.push({
                type: 'Grind Size',
                variations: grindSizeVariation,
            });
        }
        if (tinColorVariation.length > 0) {
            otherVariations.push({
                type: 'Tin Color',
                variations: tinColorVariation,
            });
        }
        if (otherVariations.length > 0) {
            resultVariant.otherVariations = otherVariations;
        }
        resultVariants.push(resultVariant);
    });
    return resultVariants;
};
exports.groupVariants = groupVariants;
var buildProductStateObject = function (response) {
    var current = response.masterData.current;
    var masterVariant = current.masterVariant, variants = current.variants, name = current.name, categories = current.categories;
    var images = masterVariant.images, masterAttributes = masterVariant.attributesRaw;
    var primaryCategoryId = getAttributeValue('primaryCategory', masterAttributes).id;
    var primaryCategory = categories.filter(function (x) { return x.id === primaryCategoryId; })[0];
    var catName = primaryCategory.name, ancestors = primaryCategory.ancestors, custom = primaryCategory.custom;
    var updatedCats = __spreadArray([], ancestors, true);
    updatedCats.push({ name: catName, custom: custom });
    var filteredAncestors = updatedCats.filter(function (ancestor) { return ancestor.name !== 'Nuts.com Categories'; });
    var url = '/';
    var resultantAncestors = filteredAncestors.map(function (ancestor) {
        var customFields = ancestor.custom
            ? ancestor.custom.customFieldsRaw
            : null;
        var categoryUrl = customFields && customFields.length > 0 ? customFields[0].value : null;
        url += "".concat(categoryUrl, "/");
        return { name: ancestor.name, url: url };
    });
    var expandedImages = imageProxied_1.default.getVariants(images);
    var allVariants = __spreadArray([masterVariant], variants, true);
    var formattedVariants = allVariants.map(function (entry) {
        var variantId = entry.id, sku = entry.sku, prices = entry.prices, otherVariations = entry.otherVariations, attributesRaw = entry.attributesRaw;
        var attributes = flattenAttributeValues(attributesRaw);
        var variant = __assign(__assign({ id: variantId, sku: sku, prices: prices, otherVariations: otherVariations }, attributes), { get packagingType() {
                return (0, sku_1.getPackagingType)(this.variantName);
            }, pricePerPound: 0, get unitName() {
                return (0, sku_1.getShortUnitName)(this.variantName);
            },
            get salePrice() {
                var primary = prices.find(function (priceObj) { return priceObj.value.currencyCode === 'USD'; });
                if (!primary) {
                    return NaN;
                }
                var centAmount = primary.value.centAmount;
                return centAmount / 100;
            },
            get isIndividuallyWrapped() {
                return (0, sku_1.isSkuIndividuallyWrapped)(this.bulk, this.wholesale, this.variantName);
            },
            get unitOfMeasurement() {
                if (!this.variantName)
                    return null;
                var lowercaseName = this.variantName.toLowerCase();
                if (lowercaseName.indexOf('ounce') > -1) {
                    return 'oz';
                }
                if (lowercaseName.indexOf('pound') > -1) {
                    return 'lb';
                }
                return '';
            }, unitPrice: 0, variationPrice: 0.0 });
        variant.pricePerPound = (0, sku_1.pricePerPoundForQuantity)(variant, 1);
        variant.unitPrice = (0, sku_1.priceForQuantity)(variant);
        return variant;
    });
    var activeVariants = formattedVariants.filter(function (entry) { return entry.active; });
    var allBackordered = activeVariants.every(function (variant) { return variant.backordered; });
    var backorderedUntil = allBackordered && activeVariants.length > 0
        ? activeVariants[0].backorderedUntil
        : '';
    var variantGroups = groupVariants(activeVariants);
    var giftVariants = [];
    var giftCertificateSku = '9990-01';
    // const listOfGiftVariants = ['$10', '$25', '$35', '$40', '$50', '$75', '$100', '$200'];
    var listOfGiftVariants = [
        { variation: 236, amount: 10 },
        { variation: 5, amount: 25 },
        { variation: 155, amount: 35 },
        { variation: 156, amount: 40 },
        { variation: 6, amount: 50 },
        { variation: 7, amount: 75 },
        { variation: 8, amount: 100 },
        { variation: 9, amount: 200 },
    ];
    if (variantGroups[0].sku === giftCertificateSku) {
        listOfGiftVariants.forEach(function (item, index) {
            var alteredVariant = __assign(__assign({}, variantGroups[0]), { checked: false, id: index + 1, unitPrice: item.amount, variation: item.variation });
            giftVariants.push(alteredVariant);
        });
        giftVariants[0].checked = true;
    }
    var product = {
        name: name,
        attributes: {
            primaryCategory: primaryCategoryId,
        },
        images: expandedImages,
        titleImage: expandedImages.length > 0 ? expandedImages[0] : null,
        variants: variantGroups[0].sku === giftCertificateSku
            ? giftVariants
            : activeVariants,
        variantGroups: variantGroups[0].sku === giftCertificateSku
            ? giftVariants
            : variantGroups,
        allBackordered: allBackordered,
        ancestors: resultantAncestors,
        backorderedUntil: backorderedUntil,
    };
    return product;
};
exports.buildProductStateObject = buildProductStateObject;
var buildPath = function (primaryCategoryWithAncestors, productUrlName, debug) {
    if (!primaryCategoryWithAncestors.ancestors[0].obj) {
        debug === null || debug === void 0 ? void 0 : debug('buildPath(): ancestors not expanded, failing');
        return;
    }
    // now assume .obj is set
    var hierarchy = __spreadArray(__spreadArray([], primaryCategoryWithAncestors.ancestors
        .map(function (ref) { return ref.obj; })
        .filter(function (cat) { var _a; return (_a = cat.custom) === null || _a === void 0 ? void 0 : _a.fields.urlName; }), true), [
        primaryCategoryWithAncestors,
    ], false);
    var urlNames = hierarchy.map(function (cat) { return cat.custom.fields.urlName; });
    urlNames.push(productUrlName);
    return "/".concat(urlNames.join('/'), ".html");
};
exports.buildPath = buildPath;
exports.default = {
    buildProductStateObject: buildProductStateObject,
    flattenAttributeValues: flattenAttributeValues,
    getAttributeValue: getAttributeValue,
    groupVariants: groupVariants,
};
//# sourceMappingURL=helpers.js.map